import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { CustomNotificationService } from './custom.notification.service';
import { OrgModulesService } from './org-modules.service';

@Injectable({
  providedIn: 'root',
})
export class BillingModuleGuard implements CanActivate {
  constructor(
    private readonly orgModulesService: OrgModulesService,
    private readonly router: Router,
    private readonly notification: CustomNotificationService,
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const hasAccess = this.orgModulesService.hasAccessToModule('billing-module');
    if (hasAccess) {
      return true;
    }

    this.notification.show(
      'warning',
      'Sin acceso',
      'Tu organización no tiene habilitado el módulo de facturación.',
      'topRight',
    );
    this.router.navigate(['/pages/dashboard'], {
      queryParams: { returnUrl: state.url },
    });
    return false;
  }
}
